var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.meeting.is_connected
    ? _c(
        "v-navigation-drawer",
        {
          staticClass: "py-4 px-4",
          attrs: { app: "", right: "", width: _vm.meeting.sidebar_width },
          scopedSlots: _vm._u(
            [
              {
                key: "append",
                fn: function () {
                  return [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          [
                            _vm.meeting.local_peer.roleName == "host"
                              ? _c(
                                  "v-btn",
                                  {
                                    class: _vm.meeting.coach_hand_raised
                                      ? "black--text"
                                      : "",
                                    attrs: {
                                      dark: false,
                                      small: "",
                                      outlined:
                                        _vm.meeting.coach_hand_raised == false,
                                      color: "yellow",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.meeting.coach_hand_raised =
                                          !_vm.meeting.coach_hand_raised
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-hand-front-right-outline")]
                                    ),
                                    _vm._v(" Coach "),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "text-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.meeting.show_nav_drawer = false
                                  },
                                },
                              },
                              [
                                _vm._v(" Close "),
                                _c("v-icon", [
                                  _vm._v("mdi-arrow-collapse-right"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            2057001340
          ),
          model: {
            value: _vm.meeting.show_nav_drawer,
            callback: function ($$v) {
              _vm.$set(_vm.meeting, "show_nav_drawer", $$v)
            },
            expression: "meeting.show_nav_drawer",
          },
        },
        [
          _c(
            "div",
            { staticClass: "rounded-pill grey align-justify" },
            [
              _vm.meeting.participants_chat_switch == "participants"
                ? _c(
                    "v-btn",
                    {
                      staticClass: "font-weight-bold",
                      attrs: {
                        rounded: "",
                        small: "",
                        color: "primary",
                        width: "50%",
                      },
                    },
                    [_vm._v("Participants")]
                  )
                : _vm._e(),
              _vm.meeting.participants_chat_switch == "participants"
                ? _c(
                    "v-btn",
                    {
                      staticClass: "font-weight-medium",
                      attrs: { rounded: "", small: "", text: "", width: "50%" },
                      on: {
                        click: function ($event) {
                          _vm.meeting.participants_chat_switch = "chat"
                        },
                      },
                    },
                    [_vm._v("Chat")]
                  )
                : _vm._e(),
              ["chat", null].includes(_vm.meeting.participants_chat_switch)
                ? _c(
                    "v-btn",
                    {
                      staticClass: "font-weight-medium",
                      attrs: { rounded: "", small: "", text: "", width: "50%" },
                      on: {
                        click: function ($event) {
                          _vm.meeting.participants_chat_switch = "participants"
                        },
                      },
                    },
                    [_vm._v("Participants")]
                  )
                : _vm._e(),
              ["chat", null].includes(_vm.meeting.participants_chat_switch)
                ? _c(
                    "v-btn",
                    {
                      staticClass: "font-weight-bold",
                      attrs: {
                        rounded: "",
                        small: "",
                        color: "primary",
                        width: "50%",
                      },
                    },
                    [_vm._v("Chat")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.meeting.local_peer &&
          _vm.meeting.participants_chat_switch == "participants"
            ? _c(
                "div",
                [
                  _c(
                    "v-list",
                    {
                      staticClass: "mt-4",
                      attrs: { subheader: "", dense: "" },
                    },
                    [
                      _c("v-subheader", [_vm._v("Hosts")]),
                      _vm._l(
                        _vm.meeting.peers.filter(
                          (peer) =>
                            peer.roleName == "host" ||
                            (peer.roleName == "coach" &&
                              _vm.meeting.local_peer.roleName != "guest")
                        ),
                        function (peer) {
                          return [
                            _c("meeting-participant-list-item", {
                              key: peer.id,
                              attrs: {
                                peer: peer,
                                local_peer: _vm.meeting.local_peer,
                              },
                            }),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                  _c("meeting-lobby-guests", {
                    key: _vm.meeting.refresh_lobby,
                  }),
                  _c("v-divider"),
                  _c(
                    "v-list",
                    { attrs: { subheader: "", dense: "" } },
                    [
                      _c(
                        "v-subheader",
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { staticClass: "pt-3" }, [
                                _vm._v("Guests"),
                              ]),
                              _c(
                                "v-col",
                                { staticClass: "text-right" },
                                [
                                  ["host", "coach"].includes(
                                    _vm.meeting.local_peer.roleName
                                  )
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { ripple: "", "x-small": "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.muteAllGuests()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [_vm._v("mdi-microphone")]
                                          ),
                                          _vm._v(" Mute All "),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(
                        _vm.meeting.peers.filter(
                          (peer) =>
                            peer.roleName == "guest" ||
                            (peer.roleName == "waiting-room" &&
                              _vm.meeting.local_peer.roleName != "guest")
                        ),
                        function (peer) {
                          return [
                            _c("meeting-participant-list-item", {
                              key: peer.id,
                              attrs: {
                                peer: peer,
                                local_peer: _vm.meeting.local_peer,
                              },
                            }),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm.meeting.local_peer
            ? _c(
                "div",
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-lg my-2", attrs: { outlined: "" } },
                    [
                      _c("v-card-subtitle", [_vm._v("Guest Chat")]),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        {
                          ref: "guest_messages",
                          staticClass: "messages-half-height",
                          staticStyle: { overflow: "auto" },
                        },
                        _vm._l(
                          _vm.meeting.messages.filter((message) =>
                            _vm.showGuestMessage(message)
                          ),
                          function (message) {
                            return _c(
                              "div",
                              { key: message.id, staticClass: "my-2" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-caption grey--text my-0",
                                  },
                                  [_vm._v(_vm._s(message.senderName))]
                                ),
                                _c("div", {
                                  staticClass: "white--text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formatBody(message.message)
                                    ),
                                  },
                                }),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      ["host", "guest"].includes(
                        _vm.meeting.local_peer.roleName
                      )
                        ? _c(
                            "v-card-actions",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  label: "Message to Guests",
                                },
                                on: { keyup: _vm.guestsMessageKeyUp },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "send-btn2",
                                              attrs: {
                                                "x-small": "",
                                                text: "",
                                              },
                                              on: {
                                                click: _vm.sendGuestsMessage,
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: { color: "secondary" },
                                                },
                                                [_vm._v("mdi-send-circle")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  728746847
                                ),
                                model: {
                                  value: _vm.message_to_guests,
                                  callback: function ($$v) {
                                    _vm.message_to_guests = $$v
                                  },
                                  expression: "message_to_guests",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  ["host", "coach", "qa"].includes(
                    _vm.meeting.local_peer.roleName
                  )
                    ? _c(
                        "v-card",
                        {
                          staticClass: "rounded-lg my-2",
                          attrs: { outlined: "" },
                        },
                        [
                          _c("v-card-subtitle", [_vm._v("Host/Coach Chat")]),
                          _c("v-divider"),
                          _c(
                            "v-card-text",
                            {
                              ref: "internal_messages",
                              staticClass: "messages-half-height",
                              staticStyle: { overflow: "auto" },
                            },
                            _vm._l(
                              _vm.meeting.messages.filter((message) =>
                                _vm.showInternalMessage(message)
                              ),
                              function (message) {
                                return _c(
                                  "div",
                                  { key: message.id, staticClass: "my-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-caption grey--text my-0",
                                      },
                                      [_vm._v(_vm._s(message.senderName))]
                                    ),
                                    _c("div", {
                                      staticClass: "white--text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatBody(message.message)
                                        ),
                                      },
                                    }),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-card-actions",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      outlined: "",
                                      label: "Message to Coaches",
                                    },
                                    on: { keyup: _vm.coachesMessageKeyUp },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function () {
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "send-btn2",
                                                  attrs: {
                                                    "x-small": "",
                                                    text: "",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.sendCoachesMessage,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        color: "secondary",
                                                      },
                                                    },
                                                    [_vm._v("mdi-send-circle")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2836575020
                                    ),
                                    model: {
                                      value: _vm.message_to_coaches,
                                      callback: function ($$v) {
                                        _vm.message_to_coaches = $$v
                                      },
                                      expression: "message_to_coaches",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }